module.exports = __webpack_public_path__ + "static/img/sky-networks-eco.56c8747.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/sky-networks-eco.jpg
// module id = EwHc
// module chunks = 0